<template>
    <div id="impact-page">
        <LandingBanner />
        <PrimaryImpact :odsStats="odsStats" :isMounted="isMounted" :odsSelected="targetId"/>
    </div>
</template>
    
<script>
import sal from 'sal.js';
import LandingBanner from '../../components/landing-components/impact-components/LandingBanner.vue';
import PrimaryImpact from '../../components/landing-components/impact-components/PrimaryImpact.vue';
import VueApexCharts from 'vue-apexcharts';
export default {
    name: "ImpactPage",
    components: {
    LandingBanner,
    PrimaryImpact,
    VueApexCharts,
},
    async mounted() {
        sal();
        await this.RgStats();
    },
    data() {
        return {
            odsStats: null,
            isMounted: false,
            targetId: null,
            series: [
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
                5.88,
            ],
            chartOptions:
            {
                "chart": {
                    "animations": {
                        "enabled": false
                    },
                    "background": "#fff",
                    // "foreColor": "#373D3F",
                    "fontFamily": "Roboto",
                    "height": 500,
                    "id": "1iaCw",
                    "toolbar": {
                        "show": false
                    },
                    "type": "pie",
                    "width": 800,
                    events: {
                        click: (event, chartContext, config) => {
                            // console.log(event.target.attributes[10].value);
                            this.targetId = event.target.attributes[10].value;
                        }
                    },
                },
                "plotOptions": {
                    "bar": {
                        "borderRadius": 10,
                        "borderRadiusApplication": "end",
                        "borderRadiusWhenStacked": "last",
                        "hideZeroBarsWhenGrouped": false,
                        "isDumbbell": false,
                        "isFunnel": false,
                        "isFunnel3d": false,
                        "dataLabels": {
                            "total": {
                                "enabled": false,
                                "offsetX": 0,
                                "offsetY": 0,
                                "style": {
                                    "color": "#373d3f",
                                    "fontSize": "12px",
                                    "fontWeight": 600
                                }
                            }
                        }
                    },
                    "bubble": {
                        "zScaling": false
                    },
                    "treemap": {
                        "dataLabels": {
                            "format": "scale"
                        }
                    },
                    "radialBar": {
                        "hollow": {
                            "background": "#fff"
                        },
                        "dataLabels": {
                            "name": {},
                            "value": {},
                            "total": {}
                        }
                    },
                    "pie": {
                        "donut": {
                            "size": "52%",
                            "labels": {
                                enabled: false,
                                "name": {},
                                "value": {},
                                "total": {}
                            }
                        }
                    }
                },
                "colors": [
                    "#e52f45",
                    "#ddaa3f",
                    "#50a03c",
                    "#c61f33",
                    "#fe4028",
                    "#2bbee2",
                    "#fbc411",
                    "#a41f47",
                    "#fc6e2d",
                    "#dd196a",
                    "#fc9f29",
                    "#c08e34",
                    "#448149",
                    "#0fa3dc",
                    "#5bc132",
                    "#066b9f",
                    "#204e6f",
                    "#f1f2f3"
                ],
                "dataLabels": {
                    "enabled": false,
                    "style": {
                        "fontWeight": 700
                    }
                },
                "fill": {
                    "opacity": 1
                },
                "grid": {
                    "padding": {
                        "right": 0,
                        "bottom": 12,
                        "left": 10
                    }
                },
                "labels": [
                    "ods1",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    ""
                ],
                "legend": {
                    "show": false,
                },
                "stroke": {
                    "width": 10,
                    "colors": [
                        "#fff"
                    ],
                    "fill": {
                        "type": "solid",
                        "opacity": 0,
                  
                    }
                },
                "tooltip": {
                    "fillSeriesColor": false,
                    enabled: false,
                },
                "xaxis": {
                    "labels": {
                        "trim": true,
                        "style": {}
                    },
                    "group": {
                        "groups": [],
                        "style": {
                            "colors": [],
                            "fontSize": "12px",
                            "fontWeight": 400,
                            "cssClass": ""
                        }
                    },
                    "title": {
                        "style": {
                            "fontWeight": 700
                        }
                    }
                },
                "yaxis": {
                    "labels": {
                        "style": {}
                    },
                    "title": {
                        "style": {
                            "fontWeight": 700
                        }
                    }
                },
            },
        }
    },
    methods: {
        async RgStats() {
            this.isMounted = false;
            const aux = await this.setRgStatsData(true);
            this.odsStats = JSON.parse(aux)
            this.isMounted = true;
        }
    }
}
</script>
    
<style scoped>
/* .banner-style-5 {
    padding: 200px 40px 0;
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/banners/banner-impacto.png") !important;
}

.banner.banner-style-5::after {
    background-color: transparent;
}

.align-self-center {
    align-self: center;
}

.large-thumb {
    position: relative;
}
.ods-img {
    filter: invert(1);
    position: absolute;
    z-index: 999;
    top: 13rem;
    left: 15rem;
    width: 13rem;
}

@media only screen and (min-width: 1200px) and (max-width: 1599px)
{
    .banner.banner-style-1 .banner-thumbnail .large-thumb img {
        width: 13rem;
    }
}*/</style> 